import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ValidPages } from '../../shared/enums/valid-pages.enum';
import { UserStore } from '../stores/user.store';

export const ApplicationGuard: CanActivateFn = async (route) => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  const page = route.data['page'] as ValidPages;

  if (!userStore.userInformation()) {
    await userStore.startAuthentication();
  }

  return userStore.checkUserHasAccess(page) ? true : router.parseUrl('/unauthorized');
};
